//import { helpers } from './helpers';

export const sliderImages = {
    animationTime: 300,
    getScrollMetrics: (wrapper) => {
        var images = wrapper.find(".slider-image");
        var maxScroll = Math.max(0, wrapper[0].scrollWidth - wrapper[0].clientWidth);
        var itemStep = 0;
        var visibleProducts = 1;
        var isFooterWidget = wrapper.closest(".dpjtrustpilot-footer-widget").length > 0;
        if (images.length > 1) {
            var firstImage = images[0].getBoundingClientRect();
            // The distance between items includes both margins and CSS gaps.
            itemStep = images[1].getBoundingClientRect().left - firstImage.left;
            if (itemStep > 0) {
                var spacing = itemStep - firstImage.width;
                var pageSize = (wrapper.width() + spacing + 1) / itemStep;
                // Footer reviews deliberately extend past the viewport to clip the outer border.
                visibleProducts = Math.max(1, isFooterWidget ? Math.round(pageSize) : Math.floor(pageSize));
                if (isFooterWidget) {
                    maxScroll = Math.min(maxScroll, Math.max(0, images.length - visibleProducts) * itemStep);
                }
            }
        }
        else if (isFooterWidget) {
            maxScroll = 0;
        }
        return { itemStep, visibleProducts, maxScroll, tolerance: isFooterWidget ? 1 : 0 };
    },
    init: () => {
        $(document).on("click", ".slider-section-wrapper .traverse-arrow", sliderImages.handleClick);
        $(".slider-images-wrapper").each(function () {
            var wrapper = $(this);
            if (sliderImages.getScrollMetrics(wrapper).maxScroll === 0) { // hide traverse arrows and continue to next iteration of loop
                wrapper.closest(".slider-section-wrapper").find(".traverse-arrow").fadeOut();
                return;
            }
            //wrapper.on("scroll", helpers.throttle(sliderImages.handleScroll(wrapper), 100));
            wrapper.on("scroll", () => {
                sliderImages.handleScroll(wrapper);
            });
        })
    },
    handleClick: (e) => {
        var clickedArrow = $(e.currentTarget);
        if (clickedArrow.css("opacity") == "0") {
            return;
        }
        var wrapper = clickedArrow.parent().find(".slider-images-wrapper");
        if (!wrapper.hasClass("slider-animation-in-progress")) {
            var metrics = sliderImages.getScrollMetrics(wrapper);
            if (metrics.itemStep <= 0) {
                return;
            }
            var direction = clickedArrow.hasClass("next") ? 1 : -1;
            var remaining = direction > 0 ? metrics.maxScroll - wrapper.scrollLeft() : wrapper.scrollLeft();
            if (remaining <= metrics.tolerance) {
                sliderImages.handleScroll(wrapper);
                return;
            }
            var scrollTo = Math.max(0, Math.min(metrics.maxScroll, wrapper.scrollLeft() + direction * metrics.visibleProducts * metrics.itemStep));
            wrapper.addClass("slider-animation-in-progress");
            //wrapper.animate({ 'scrollLeft': scrollTo }, sliderImages.animationTime);
            wrapper.animate({scrollLeft: scrollTo}, {
                duration: sliderImages.animationTime,
                step: () => {
                    sliderImages.handleScroll(wrapper);
                },
                complete: () => {
                    sliderImages.handleScroll(wrapper);
                }
            });
            setTimeout(() => {
                wrapper.removeClass("slider-animation-in-progress");
            }, sliderImages.animationTime);
        }
    },
    handleScroll: (wrapper) => {
        var scrollIndex = 1;
        var itemOuterWidth = 0;
        var gap = parseInt(wrapper.find(".slider-image").parent().css("gap"));
        if (isNaN(gap)) { // calculate with margins
            itemOuterWidth = wrapper.find(".slider-image").outerWidth(true) - 1;
        }
        else { // calculate with gap
            itemOuterWidth = wrapper.find(".slider-image").width() + gap - 1;
        }
        scrollIndex = wrapper.scrollLeft() / itemOuterWidth ? Math.ceil(wrapper.scrollLeft() / itemOuterWidth) : 1;
        wrapper.data("scroll-index", scrollIndex);
        var metrics = sliderImages.getScrollMetrics(wrapper);
        var nextOpacity = wrapper.scrollLeft() < metrics.maxScroll - metrics.tolerance ? .9 : 0;
        var prevOpacity = wrapper.scrollLeft() > metrics.tolerance ? .9 : 0;
        if (wrapper.scrollLeft()) {
            wrapper.parent().find(".traverse-arrow").show();
        }
        wrapper.parent().find(".traverse-arrow.prev").css("opacity", prevOpacity);
        wrapper.parent().find(".traverse-arrow.next").css("opacity", nextOpacity);
    }
}
